var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sv-codeeditor-container"},[_c('div',{ref:"monacoEditorCode",staticClass:"sv-monaco-editor",attrs:{"id":"monaco-editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }